import React from 'react';
import classNames from 'classnames';
import {
  MdClear as ExitIcon,
  MdPriorityHigh as WarningIcon,
  MdSave as SaveIcon,
  MdSettings as SettingsIcon,
} from 'react-icons/md';
import Spinner from '../../shared/spinner.component';
import { POPUP_CALLER_CLASS } from '../../shared/detailPopup.component';
import { EDIT_HELP_SETTINGS_POPUP } from '../shared/constants';

type IconGroupProps = {
  readOnly?: boolean,
  updating?: boolean,
  onClose?: () => void,
  onSave?: () => void,
  warning?: boolean
};

export const IconGroup = ({
  readOnly,
  updating,
  onClose,
  onSave,
  warning,
}: IconGroupProps) => {
  if (readOnly) {
    return (
      <div className="HelpContent-topRightIconGroup">
        <div className="HelpContent-saveIconContainer">
          <ExitIcon onClick={onClose} className="popup-header-exit" />
        </div>
      </div>
    );
  }
  if (updating) {
    return <Spinner small />;
  }
  if (warning) {
    return (
      <div className="HelpContent-topRightIconGroup">
        <div className="HelpContent-saveIconContainer">
          <WarningIcon className="HelpContent-warningIcon" />
          <SaveIcon onClick={onSave} className="HelpContent-saveIcon" />
        </div>
      </div>
    );
  }

  return (
    <div className="HelpContent-topRightIconGroup">
      <div
        className={classNames('HelpContent-settingsIconContainer', POPUP_CALLER_CLASS)}
      >
        <SettingsIcon
          data-tip=""
          data-for={EDIT_HELP_SETTINGS_POPUP}
          className={classNames('HelpContent-settingsIcon', POPUP_CALLER_CLASS)}
        />
      </div>
      <div className="HelpContent-saveIconContainer">
        <SaveIcon onClick={onSave} className="HelpContent-saveIcon" />
      </div>
    </div>
  );
};
